const AutoCompleteAddress = ({
    city = '',
    name = '',
    propertyId = '',
    state = '',
    street = '',
} = {}) => ({
    city: String(city),
    name: String(name),
    propertyId: String(propertyId),
    state: String(state),
    street: String(street),
});

export default AutoCompleteAddress;
